<template>
  <ModalEndPage
    v-if="isVisible"
    :title="dataToPass.title"
    :subtitle="dataToPass.subtitle"
    :actions="dataToPass.actions"
    :main-color="mainColor"
    :button-color="buttonColor"
  />
</template>

<script>
import router from "@/router";
import modalService from "@/lib/services/modal-service";

import ModalEndPage from "@/forms/components/shared/modal-and-end-page";

const WHITE = "white";
const PURPLE = "purple";

export default {
  components: {
    ModalEndPage
  },

  computed: {
    isVisible() {
      return router.isOnEndPage || router.isOnModal;
    },

    mainColor() {
      return router.isOnModal ? WHITE : PURPLE;
    },

    buttonColor() {
      return router.isOnModal ? PURPLE : WHITE;
    },

    dataToPass() {
      if (router.isOnModal) {
        return this.modalData;
      }
      if (router.isOnEndPage) {
        return this.endPageData;
      }

      return {};
    },

    modalData() {
      return modalService.modalData;
    }
  },

  props: {
    endPageData: {
      required: true,
      type: Object
    }
  }
};
</script>
